import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'semantic-ui-react';
import _ from 'lodash';

const footnotesList = [
  {
    id: 1,
    symbol: '*',
    note: [<p key="0">For example, coverage through an HMO or PPO provided by an employer.</p>],
  },
  {
    id: 2,
    symbol: '†',
    note: [<p key="0">By enrolling in the Takeda Oncology Co-Pay Assistance Program (the “Program”), you acknowledge that
    you currently meet the eligibility criteria and will comply with the following terms and conditions:</p>],
  },
  {
    // for patient re-enroll / casemanagers
    id: 2.5,
    symbol: '*',
    note: [<p key="0">By enrolling in the Takeda Oncology Co-Pay Assistance Program (the “Program”), you acknowledge that
    you currently meet the eligibility criteria and will comply with the following terms and conditions:</p>],
  },
  {
    id: 3,
    symbol: '',
    note: [<p key="0">You must be at least 18 years old, a resident of the United States or a US Territory, and have commercial (private) prescription insurance that does not cover the entire cost of the Takeda Oncology medication. The Program is not valid for patients whose prescription claims for the Takeda Oncology medication are eligible to be reimbursed, in whole or in part, by any state or federal healthcare program, including, but not limited to, Medicare, Medicaid, Department of Defense (DoD), Veterans Affairs (VA), TRICARE, or any state or territory pharmaceutical assistance program. Patients who become eligible for or start using government insurance for their Takeda Oncology medications will no longer be eligible for the Program. The Program is not valid if the entire cost of your prescription is reimbursable by a private insurance plan or other private health or pharmacy benefit programs. You are responsible for reporting receipt of Program assistance to any insurer, health plan, or other third party who pays for or reimburses any part of the medication cost, as may be required.</p>],
  },
  {
    id: 4,
    symbol: '',
    note: [<p key="0">You agree that you will not submit the cost of any portion of the product dispensed pursuant to this Program to a federal or state healthcare program (including, but not limited to, Medicare, Medicaid, TRICARE, VA, DoD, etc.), for purposes of counting it toward your out-of-pocket expenses, and to notify Takeda Oncology Here2Assist&reg; if you become eligible for a federal or state healthcare program that covers your Takeda Oncology medication. This Program is not conditioned on any past, present or future purchase of any Takeda product, including refills. This Program is valid for up to 12 months, and your co-pay card may be renewed every 12 months, subject to continued eligibility at the beginning of each calendar year. This offer is not valid with any other program, discount, or offer involving your prescribed Takeda Oncology medication. This offer may be rescinded, revoked, or amended without notice. This offer is void where prohibited by law, taxed, or restricted. Limit one offer per purchase. No income requirements or membership fees. This Program is not health insurance. Cash value of 1/100 of 1¢. For questions about this offer, please contact the Takeda Oncology Co-Pay Assistance Program, a patient support service of Takeda Oncology Here2Assist, at 1-844-817-6468, Option 2, Monday-Friday, 8AM-8PM ET.</p>],
  },
];

const Footnotes = props => {
  const footnotesArray = _.map(props.footnotes, footnoteId => {
    return _.find(footnotesList, footnote => {
      if (footnoteId === footnote.id) {
        return footnote;
      }
    });
  });

  return (
    <div className="footnotes full-width">
      <div className={ `wrapper ${props.customClass || ''}` }>
        <List as="ol">
          { footnotesArray.map((footnote, key) => (
            <List.Item key={ key } as='li' className={ footnote.symbol !== '*' ? 'sup-footnote' : '' } value={ footnote.symbol }>{ footnote.note }</List.Item>
          ))}
        </List>
      </div>
    </div>
  );
};

Footnotes.propTypes = {
  footnotes: PropTypes.array.isRequired,
  customClass: PropTypes.string,
};

export default Footnotes;
